import IobItem from "../Domain/IobItem";
import serviceHelper from "../Helpers/serviceHelper";
import AuthService from "./authService";
import SearchParams from "../Elements/SearchParams";
import IobSearchParams from "../Contents/Operations/IOB/IobSearchParams";

export default class IobService {
    static GetIobList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
        const authService = AuthService.getInstance();
        let url = 'api/Iob/GetAllBySearchingAsync/?';

        const searchParams = new SearchParams(searchItem, IobSearchParams, orderById, orderDir, pageNumber, numberOfElements);

        url += `searchParams=${searchParams.serializeForBackendCall()}`;
        url += `&clearCache=${clearCache}`;

        return authService.CallBackendFunction(url);
    }

    static ConvertDBItemList(items) {
        const convertedItems = [];

        if (items !== null) {
          items.forEach((item) => {
            const newItem = new IobItem(item);
            convertedItems.push(newItem);
          });
        }

        return convertedItems;
    }

    static GetById(id) {
        const authService = AuthService.getInstance();
        const url = `/api/Iob/GetByIdAsync/${id}`;
        return authService.CallBackendFunction(url);
    }

    static UpsertIob(item) {
        item = serviceHelper.ConvertAllPropertyToString(item)

        const JSONItem = JSON.stringify(item);

        let url = "/api/Iob/PostIobAsync";

        if (item["IobinvoiceId"] !== "")
        {
            url = "/api/Iob/EditIobAsync"
            return AuthService.getInstance()
                .CallBackendFunctionPut(url, JSONItem)
        }
        return AuthService.getInstance()
            .CallBackendFunctionPost(url, JSONItem)
    }

    static GetInvoiceById(item) {
        return AuthService.getInstance()
            .CallBackendFunction(
                "/api/Iob/GetInvoiceById?"
                + "&searchItem=" + JSON.stringify(item)
            );
    }

    static FinalizeIobAsync(id, reason) {
        const finalizationData = { Reason: reason, IobinvoiceId: id };

        const JSONItem = JSON.stringify(finalizationData);

        const url = '/api/Iob/FinalizeIobAsync';
        return AuthService.getInstance()
            .CallBackendFunctionPut(url, JSONItem);
    }

    static AttachReportAsync(id) {
        const url = `/api/Iob/AttachReportAsync/${id}`;

        return AuthService.getInstance()
            .CallBackendFunctionPut(url);
    }

    static MarkIobAsPaidAsync(id, reason) {
        const markAsPaidData = { Reason: reason, IobinvoiceId: id };

        const JSONItem = JSON.stringify(markAsPaidData);

        const url = '/api/Iob/MarkIobAsPaidAsync';
        return AuthService.getInstance()
            .CallBackendFunctionPut(url, JSONItem);
    }

    static MarkMultipleIobsAsPaidAsync(ids, reason) {
        const markAsPaidData = { Reason: reason, IobinvoiceIds: ids };

        const JSONItem = JSON.stringify(markAsPaidData);

        const url = '/api/Iob/MarkMultipleIobsAsPaidAsync';
        return AuthService.getInstance()
            .CallBackendFunctionPut(url, JSONItem);
    }
}